import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=495b75da&"
import script from "./LoginButton.js?vue&type=script&lang=js&"
export * from "./LoginButton.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports